import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      userDetails: {
        form: {
          email: {
            type: 'input',
            name: 'email',
            label: 'Email *',
            placeholder: 'Enter email',
            value: null,
            class: 'col-6 pr-12px',
            disabled: false,
            validation: [{ name: 'required' }],
            skipValidation: (fields) => fields.email.disabled
          },
          'roles': {
            type: 'multiselect',
            name: 'roles',
            label: 'Roles *',
            valueField: 'id',
            selectLabel: 'display_name',
            placeholder: 'Select roles',
            validation: [{ name: 'required' }],
            options: [],
            value: null,
            class: 'col-6 pl-12px',
            disabled: false
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getRoles: 'getRoles'
    })
  },
  watch: {
    getRoles: {
      handler (newRoles) {
        if (newRoles && newRoles.length) {
          this.setUserDetailsRolesOptions(newRoles)
        }
      },
      immediate: true
    }
  },
  async mounted () {
    await this.fetchRoles()
  },
  methods: {
    ...mapActions({
      fetchRoles: 'fetchRoles'
    }),
    fillUserDetailsData (data) {
      this.userDetails.form.email.value = data.email || null
      this.userDetails.form.roles.value = data.roles || null
    },
    disableUserDetailsEmail () {
      this.userDetails.form.email.disabled = true
    },
    disableUserDetailsRoles () {
      this.userDetails.form.roles.disabled = true
    },
    setUserDetailsRolesOptions (roleOptions) {
      this.userDetails.form.roles.options = roleOptions
    }
  }
}
